import { render, staticRenderFns } from "./CompanyAwayDetailCreateForm.vue?vue&type=template&id=2369cd38&scoped=true&"
import script from "./CompanyAwayDetailCreateForm.vue?vue&type=script&lang=js&"
export * from "./CompanyAwayDetailCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2369cd38",
  null
  
)

export default component.exports